import { Heading, Text } from "@chakra-ui/react";
import { useApiPageContext } from "context/ApiPagecontext";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const ApiBlockGettingStarted = () => {
  const usersApiKey = useSelector((state: RootState) => state.apiKey.apiKey);
  const isUserLoggedIn = useSelector(
    (state: RootState) => state.userData.isUserLoggedIn
  );

  const { setSelectedLanguage, setSelectedTool } = useApiPageContext();

  useEffect(() => {
    setSelectedLanguage("Shell");
    setSelectedTool("cURL");
  }, [setSelectedLanguage, setSelectedTool]);

  return (
    <div>
      <Heading mb={4}>Getting Started with the ipscore.app API</Heading>
      <Text>
        Welcome to ipscore.app API docs, your go-to service for IP address data!
        Our API empowers you to access comprehensive information about IP
        addresses, enabling you to integrate this valuable data into your
        applications and services seamlessly. In this guide, we'll walk you
        through the steps to get started with our API and make the most out of
        its capabilities.
      </Text>
      <Heading mt={4} mb={4} id="authethication">
        Authentication
      </Heading>
      <Text>
        To use the ipscore.app API, you'll need an API key for authentication.
      </Text>
      {isUserLoggedIn ? (
        <>
          <Text>
            Here is your API key: <br />
          </Text>
          <Heading size="sm">{usersApiKey}</Heading>
        </>
      ) : (
        <Text>
          You can obtain your unique API key by signing up on ipscore.app and
          accessing your account dashboard.
        </Text>
      )}
    </div>
  );
};

export default ApiBlockGettingStarted;
